import { useEffect } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";

const useFormErrorHandling = (setError: any, apiError: any) => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (!apiError) return;

    const status = apiError.originalStatus || apiError.status;

    switch (status) {
      case 400:
        if (apiError.data?.error) {
          apiError.data.error.forEach((error: { path: string[]; message: string }) => {
            const fieldName: string = error.path?.[error.path.length - 1] || "general";
            setError(fieldName === "body" ? "general" : fieldName, {
              type: "manual",
              message: error.message,
            });
          });
        } else {
          setError("general", {
            type: "manual",
            message: apiError.data?.message || formatMessage({ id: "error.validation" }),
          });
        }
        break;

      case 401:
        toast.error(formatMessage({ id: "error.unauthorized" }));
        break;

      case 409:
        // Manejamos conflicto como un error de campo, por ejemplo: NIF duplicado
        setError("nif", {
          type: "manual",
          message: apiError.data?.error || formatMessage({ id: "error.conflict" }),
        });
        break;

      default:
        // Mostramos el error en un toast pero no rompemos React
        toast.error(formatMessage({ id: "error.serverError" }));
        break;
    }
  }, [apiError, setError, formatMessage]);
};

export default useFormErrorHandling;
